export default __webpack_public_path__ + "static/media/calender.7e39866a.svg";